<template>
  <b-card>
    <b-row class="ml-1">
      <b-card-title>Employee Agreement Renewals</b-card-title>

      <div class="button-style">
        <b-button
          class="flex-shrink-0 mr-1"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          @click="goEmployees"
        >
        <feather-icon icon="ClipboardIcon" />
        </b-button>
      </div>
    </b-row>

    <b-table responsive="sm" :items="items" :fields="fields" sticky-header height="300px">
      <template #cell(name)="data">
        <span class="font-weight-bold cursor-pointer text-primary" @click="moveToDetails(data.item?.data?.id)">{{ data.item?.name }}</span>
      </template>
    </b-table>
  </b-card>
</template>

<script>
import {
  BCard,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BButton,
  BForm,
  BModal,
  BSpinner,
  BCol,
  BRow,
  BFormDatepicker,
  BFormTextarea,
  BLink,
  BMedia,
  BMediaAside,
  BMediaBody,
  BCardText,
  BTable, BCardTitle,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { mapGetters } from "vuex";
import { EventBus } from "@/helpers/event-bus";

export default {
  name: "UpcomingAgreementRenewalWidget",
  components: {
    BForm,
    BButton,
    BCard,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    ValidationProvider,
    ValidationObserver,
    BModal,
    BSpinner,
    BCol,
    BRow,
    BFormDatepicker,
    BFormTextarea,
    BLink,
    BMedia,
    BMediaAside,
    BMediaBody,
    BCardText,
    BTable,
    BCardTitle
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      // filter
      items: [
        {
          name: "",
          join_date: "No Data Found",
          renewal_date: "",
        },
      ],
      fields: [
        { key: 'name', label: 'Name', sortable: false },
        { key: 'join_date', label: 'Join Date' },
        { key: 'renewal_date', label: 'Renewal Date', sortable: false },
      ],
    };
  },

  computed: {
    ...mapGetters({
      permissions: "userModule/getPermissions",
    }),
  },

  async created() {
    try {
      this.loadItems();
    } catch (error) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          icon: "BellIcon",
          variant: "danger",
          text: error?.response?.data?.message,
        },
      });
    }
  },
  methods: {
    moveToDetails(id){
      this.$router.push({
        name: 'user-profile',
        params: { id },
      })
    },
    formatDate(value) {
      if (value) {
        return this.$moment(value).format("MMM Do YYYY");
      }
      return "Not Set";
    },

    goEmployees() {
      this.$router.push({
        name: "admin-users",
      });
    },

    onShowPage(id) {
      this.$router.push({
        name: "admin-attendance-details",
        params: { id },
      });
    },

    async getAgreementRenewal() {
      return await this.$api.get("api/dashboard/employee-agreement-renewals");
    },

    async loadItems() {
      try {
        const userData = await this.getAgreementRenewal();

        if (userData?.data?.data.length > 0) {
          this.items = userData?.data?.data.map((item) => {
            return {
              data: item,
              name: item?.name,
              join_date: this.formatDate(item?.join_date),
              renewal_date: this.formatDate(item?.agreement_renewal_date),
            };
          });
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Warning",
            icon: "BellIcon",
            variant: "warning",
            text: error?.response?.data?.message,
          },
        });
      }
    },
  },
};
</script>

    <style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
.table-custom-style-att {
  white-space: nowrap !important;
  min-height: 140px !important;
  tr,
  th,
  td {
    vertical-align: middle !important;
    text-align: center !important;
    font-size: 12px !important;
  }
}
.custom-font {
  font-size: 13px !important;
}
</style>
